import { Shield } from 'lucide-react'
import type { ReactNode } from 'react'

export interface FormTipProps {
  children: ReactNode
}

export function FormTip({ children }: FormTipProps) {
  return (
    <div
      style={{
        display: 'flex',
        gap: 10,
        marginTop: 16,
        padding: 14,
        background: 'var(--surface-tint)',
        border: '1px solid var(--emerald-100)',
        borderRadius: 'var(--radius-md)',
      }}
    >
      <span style={{ color: 'var(--emerald-700)', flexShrink: 0 }}>
        <Shield size={18} />
      </span>
      <p
        style={{
          fontSize: 13.5,
          color: 'var(--ink-2)',
          lineHeight: 1.55,
          margin: 0,
        }}
      >
        {children}
      </p>
    </div>
  )
}
